import React from 'react';
import { Calendar, Clock, Users, ChevronRight } from 'lucide-react';
import { Intervention } from '../../../types/contentTypes';
import { getInterventionCategoryLabel } from '../../../utils/categoryHelpers';

interface InterventionDetailProps {
  intervention: Intervention;
  onBack: () => void;
}

const InterventionDetail: React.FC<InterventionDetailProps> = ({ intervention, onBack }) => {
  return (
    <div>
      <button 
        onClick={onBack}
        className="text-primary hover:text-primary-700 font-medium flex items-center mb-6"
      >
        <ChevronRight className="h-4 w-4 mr-1 rotate-180" />
        Nazaj na seznam
      </button>
      
      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        <div className="h-96 overflow-hidden">
          <img 
            src={intervention.image} 
            alt={intervention.title} 
            className="w-full h-full object-cover" 
          />
        </div>
        <div className="p-6 md:p-8">
          <div className="flex flex-wrap gap-3 mb-4">
            <span className="bg-primary/10 text-primary text-sm font-medium px-3 py-1 rounded-full">
              {getInterventionCategoryLabel(intervention.category)}
            </span>
            <span className="bg-gray-100 text-gray-700 text-sm px-3 py-1 rounded-full flex items-center">
              <Calendar className="h-4 w-4 mr-1" />
              {new Date(intervention.date).toLocaleDateString('sl-SI')}
            </span>
            <span className="bg-gray-100 text-gray-700 text-sm px-3 py-1 rounded-full flex items-center">
              <Clock className="h-4 w-4 mr-1" />
              {intervention.time}
            </span>
            <span className="bg-gray-100 text-gray-700 text-sm px-3 py-1 rounded-full flex items-center">
              <Users className="h-4 w-4 mr-1" />
              {intervention.participants} gasilcev
            </span>
          </div>
          
          <h1 className="text-3xl font-bold text-secondary mb-4">{intervention.title}</h1>
          <p className="text-gray-700 text-lg mb-6">{intervention.excerpt}</p>
          
          <div className="prose max-w-none">
            {intervention.content.split('\n\n').map((paragraph, index) => (
              <p key={index} className="mb-4 text-gray-700">{paragraph}</p>
            ))}
          </div>
          
          <div className="mt-8 pt-6 border-t border-gray-100">
            <h3 className="font-medium text-secondary mb-2">Lokacija intervencije:</h3>
            <p className="text-gray-700">{intervention.location}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterventionDetail;